{
  "order": {
    "unpaid": "ยังไม่ชำระ",
    "pending": "รอดำเนินการ",
    "packed": "แพ็คแล้ว",
    "awaiting_shipment": "รอจัดส่ง",
    "ready_to_ship": "พร้อมส่ง",
    "shipped": "จัดส่งแล้ว",
    "delivered": "ส่งถึงปลายทาง",
    "cancelled": "ยกเลิก",
    "returned": "คืนสินค้า",
    "lost_by_3pl": "สูญหายโดย 3PL",
    "damaged_by_3pl": "เสียหายโดย 3PL",
    "confirmed": "ยืนยันแล้ว",
    "completed": "เสร็จสิ้น"
  },
  "payment": {
    "pending": "รอชำระ",
    "paid": "ชำระแล้ว",
    "failed": "ชำระไม่สำเร็จ"
  },
  "promotion": {
    "draft": "ฉบับร่าง",
    "active": "กำลังใช้งาน",
    "finished": "สิ้นสุดแล้ว"
  },
  "stock": {
    "healthy": "ปกติ",
    "low_stock": "ใกล้หมด",
    "out_of_stock": "หมดสต๊อก",
    "oversold": "ขายเกินสต๊อก"
  },
  "sync": {
    "in_progress": "กำลังซิงค์",
    "ok": "ซิงค์แล้ว",
    "failed": "ซิงค์ล้มเหลว"
  }
}
